import React, { useState } from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { EntityDTO } from '../../DocumentVault.meta';
import { Complete } from './components/Complete/Complete';
import { MoveItems } from './components/MoveItems/MoveItems';
import { SelectItems } from './components/SelectItems/SelectItems';
import { OrganizeItemsContextProvider } from './context/OrganizeItemsContext';
import { useOrganizeModal } from './useOrganizeModal';

const StepComponentMap = {
  1: SelectItems,
  2: MoveItems,
  3: Complete,
};

interface Props {
  selectedEntity: EntityDTO;
  onClose: () => void;
}

export const OrganizeModal = ({ selectedEntity, onClose }: Props) => {
  const [step, setStep] = useState(1);

  const {
    destinationPath,
    isLoading,
    data,
    navigatePath,
    setDestinationPath,
    setNavigatePath,
    setSourcePath,
    sourcePath,
    sourceEntities,
  } = useOrganizeModal({ selectedEntity });

  if (!sourceEntities) {
    return null;
  }

  const Component = StepComponentMap[step];

  return (
    <Modal isOpen onRequestClose={onClose} shouldCloseOnOverlayClick={false}>
      <ModalHeader variant="warning">Organize Folder</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <OrganizeItemsContextProvider
        value={{
          isLoading,
          data,
          onBack: () => setStep(state => state - 1),
          onClose,
          onNext: () => setStep(state => state + 1),
          destinationPath,
          navigatePath,
          setDestinationPath,
          setNavigatePath,
          setSourcePath,
          sourcePath,
          sourceEntities,
        }}
      >
        <Component />
      </OrganizeItemsContextProvider>
    </Modal>
  );
};
